import { createFileRoute, Outlet, useMatch, useNavigate } from '@tanstack/react-router';
import { WomenList } from '../app/components/woman/women-list';
import { ProtectedRoute } from '@org/ui';

export const Route = createFileRoute('/women')({
  component: WomenRoute,
});

const WOMEN_PERMISSIONS = ['admin:all'];

function WomenRoute() {
  const navigate = useNavigate({ from: '/women' });
  // The editor (/women/$womanId) is a page of its own: while it is open the
  // list is not rendered underneath. /women/new stays a modal over the list.
  const editorMatch = useMatch({ from: '/women/$womanId', shouldThrow: false });

  return (
    <ProtectedRoute requiredPermissions={WOMEN_PERMISSIONS}>
      {editorMatch ? (
        <Outlet />
      ) : (
        <div className="space-y-6">
          <WomenList
            onCreateWoman={() => navigate({ to: '/women/new' })}
            onEditWoman={(woman) =>
              navigate({ to: '/women/$womanId', params: { womanId: woman.womanId } })
            }
          />
          <Outlet />
        </div>
      )}
    </ProtectedRoute>
  );
}
